<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableCentroCusto"
                            :options="form.centrosCusto"
                            @change="loadFrom('centroCusto')"
                            default-option-text="Todos"
                            label="Setor"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.centroCustoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disableTipo"
                            :options="form.tipos"
                            @change="loadFrom('tipo')"
                            default-option-text="Todos"
                            label="Tipo"
                            show-default-option
                            text-field="nome"
                            v-model="model.tipoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disableMotivo"
                            :options="form.motivos"
                            @change="loadFrom('motivo')"
                            default-option-text="Todos"
                            label="Motivo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.motivoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuarioSaida"
                            :options="form.usuariosSaida"
                            @change="loadFrom('usuarioSaida')"
                            default-option-text="Todos"
                            label="Usuário que realizou a saída"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioSaidaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidadeRequisitante"
                            :options="form.unidadesRequisitantes"
                            @change="loadFrom('unidadeRequisitante')"
                            default-option-text="Todas"
                            label="Unidade requisitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestruturaRequisitante"
                            :options="form.infraestruturasRequisitantes"
                            @change="loadFrom('infraestruturaRequisitante')"
                            default-option-text="Todos"
                            label="Local de atendimento requisitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableCentroCustoRequisitante"
                            :options="form.centrosCustoRequisitantes"
                            @change="loadFrom('centroCustoRequisitante')"
                            default-option-text="Todos"
                            label="Setor requisitante"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.centroCustoRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuarioRequisitante"
                            :options="form.usuariosRequisitantes"
                            @change="loadFrom('usuarioRequisitante')"
                            default-option-text="Todos"
                            label="Usuário requisitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioRequisitanteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableGrupo"
                            :options="form.grupos"
                            @change="loadFrom('grupo')"
                            default-option-text="Todos"
                            label="Grupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.grupoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableSubgrupo"
                            :options="form.subgrupos"
                            @change="loadFrom('subgrupo')"
                            default-option-text="Todos"
                            label="Subgrupo"
                            show-default-option
                            text-field="nome"
                            v-model="model.subgrupoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="disableMaterial"
                            :repository="repositories.relatorioSaida.material"
                            :request-query-string-params="autocompleteQueryStringParams.material"
                            :search-fields="autocompleteFields.material"
                            text-field="descricao"
                            label="Material"
                            uppercase
                            v-model="model.material"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :foot-clone="itens.length > 0"
                :items="itens"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
                no-footer-sorting
            >
                <template #cell(dataRequisicao)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(codigoMaterial)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(lote)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(validade)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(subgrupo)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(motivo)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(justificativa)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(unidadeRequisitante)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(infraestruturaRequisitante)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(setorRequisitante)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #cell(usuarioRequisitante)="{ value }">
                    {{ value || '-' }}
                </template>

                <template #foot(dataHoraSaida)>
                    <span></span>
                </template>

                <template #foot(dataRequisicao)>
                    <span></span>
                </template>

                <template #foot(tipo)>
                    <span></span>
                </template>

                <template #foot(codigoMaterial)>
                    <span></span>
                </template>

                <template #foot(material)>
                    <span></span>
                </template>

                <template #foot(lote)>
                    <span></span>
                </template>

                <template #foot(validade)>
                    <span></span>
                </template>

                <template #foot(grupo)>
                    <span></span>
                </template>

                <template #foot(subgrupo)>
                    <span></span>
                </template>

                <template #foot(motivo)>
                    <span></span>
                </template>

                <template #foot(justificativa)>
                    <span></span>
                </template>

                <template #foot(unidade)>
                    <span></span>
                </template>

                <template #foot(infraestrutura)>
                    <span></span>
                </template>

                <template #foot(setor)>
                    <span></span>
                </template>

                <template #foot(usuarioSaida)>
                    <span></span>
                </template>

                <template #foot(unidadeRequisitante)>
                    <span></span>
                </template>

                <template #foot(infraestruturaRequisitante)>
                    <span></span>
                </template>

                <template #foot(setorRequisitante)>
                    <span></span>
                </template>

                <template #foot(usuarioRequisitante)>
                    <span></span>
                </template>

                <template #foot(quantidade)>
                    <span>{{ getSafely(() => totalizadores.quantidade, 0) }}</span>
                </template>

                <template #afterTable>
                    <rkm-row class="mt-2">
                        <rkm-col class="text-center font-weight-bold">
                            <span
                                v-for="(tipo, i) in getSafely(() => totalizadores.tipos, [])"
                                :key="tipo.id"
                            >
                                <template v-if="i > 0">|</template> {{ tipo.nome }}: {{ tipo.quantidade }}
                            </span>
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import formatsFilter from '@/filters/formats'
import { mapActions } from 'vuex'
import { repository, error, data, object, stringCase, file } from '@/mixins'
import saidaTipo from '@/enums/almoxarifado/saidaTipo'
import motivoBaixaTipo from '@/enums/almoxarifado/motivoBaixaTipo'

export default {
    computed: {
        autocompleteQueryStringParams() {

            const params = this.prepareData()

            delete params.material_id

            return {
                material: { ...params }
            }
        },
        autocompleteFields() {

            return {
                material: [
                    { key: 'codigo_material', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            }
        },
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
                || !this.additionals.isAlmoxarifado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || !this.additionals.isAlmoxarifado
                || this.model.unidadeId === null
        },
        disableCentroCusto() {

            return !this.isPeriodoSelecionado
                || !this.additionals.isAlmoxarifado
                || this.model.infraestruturaId === null
        },
        disableTipo() {

            return !this.isPeriodoSelecionado
        },
        disableMotivo() {

            return !this.isPeriodoSelecionado
                || this.model.tipoId != this.enums.saidaTipo.BAIXA
        },
        disableUsuarioSaida() {

            return !this.isPeriodoSelecionado
        },
        disableUnidadeRequisitante() {

            return !this.isPeriodoSelecionado || [
                this.enums.saidaTipo.INVENTARIO,
                this.enums.saidaTipo.BAIXA,
                this.enums.saidaTipo.DISPENSACAO_FARMACIA,
            ].includes(this.model.tipoId)
        },
        disableInfraestruturaRequisitante() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeRequisitanteId === null
        },
        disableCentroCustoRequisitante() {

            return !this.isPeriodoSelecionado
                || this.model.infraestruturaRequisitanteId === null
        },
        disableUsuarioRequisitante() {

            return !this.isPeriodoSelecionado || [
                this.enums.saidaTipo.INVENTARIO,
                this.enums.saidaTipo.DISPENSACAO_FARMACIA,
            ].includes(this.model.tipoId) || (
                this.model.tipoId == this.enums.saidaTipo.BAIXA
                && this.model.motivoId !== null
                && this.form.motivos
                    .find(m => m.id == this.model.motivoId).tipoId !== this.enums.motivoBaixaTipo.CONSUMO_INTERNO
            )
        },
        disableGrupo() {

            return !this.isPeriodoSelecionado
        },
        disableSubgrupo() {

            return !this.isPeriodoSelecionado
                || this.model.grupoId === null
        },
        disableMaterial() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            relatorioSaida: this.getConectaSusRepository('almoxarifado.relatorioSaida'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
            exportacao: this.getConectaSusRepository('exportacao.almoxarifado'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
                'dataRequisicao',
                'tipo',
                'codigoMaterial',
                'lote',
                'validade',
            ],
            sortBy: 'dataHoraSaida',
            sortDesc: false,
            columns: [
                {
                    key: 'dataHoraSaida',
                    label: 'Data/hora da saída',
                    sortable: true,
                    class: 'col-min text-center',
                    formatter: value => this.formatDateTime(value),
                    filterByFormatted: true,
                    fixed: true,
                },
                {
                    key: 'dataRequisicao',
                    label: 'Data da requisição',
                    sortable: true,
                    class: 'col-min text-center',
                    formatter: value => this.isNullOrEmptyString(value) ? '' : this.formatDate(value),
                    filterByFormatted: true,
                },
                { key: 'tipo', label: 'Tipo', sortable: true, class: 'col-min text-center' },
                { key: 'codigoMaterial', label: 'Código do material', sortable: true, class: 'col-min text-center' },
                { key: 'material', label: 'Material', sortable: true, fixed: true },
                { key: 'lote', label: 'Lote', sortable: true, class: 'col-min text-center' },
                {
                    key: 'validade',
                    label: 'Validade',
                    sortable: true,
                    class: 'col-min text-center',
                    formatter: value => this.isNullOrEmptyString(value) ? '' : this.formatDate(value),
                    filterByFormatted: true,
                },
                { key: 'grupo', label: 'Grupo', sortable: true },
                { key: 'subgrupo', label: 'Subgrupo', sortable: true },
                { key: 'motivo', label: 'Motivo', sortable: true, class: 'col-min text-center' },
                { key: 'justificativa', label: 'Justificativa', sortable: true },
                { key: 'unidade', label: 'Unidade', sortable: true },
                { key: 'infraestrutura', label: 'Local de atendimento', sortable: true },
                { key: 'setor', label: 'Setor', sortable: true },
                { key: 'usuarioSaida', label: 'Usuário que realizou a saída', sortable: true },
                { key: 'unidadeRequisitante', label: 'Unidade requisitante', sortable: true },
                { key: 'infraestruturaRequisitante', label: 'Local de atendimento requisitante', sortable: true },
                { key: 'setorRequisitante', label: 'Setor requisitante', sortable: true },
                { key: 'usuarioRequisitante', label: 'Usuário requisitante', sortable: true },
                { key: 'quantidade', label: 'Quantidade', sortable: true, class: 'col-min text-center', fixed: true }
            ],
            itens: [],
            totalizadores: null,
            enums: { saidaTipo, motivoBaixaTipo },
        }
    },
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        load() {

            this.setLoading()

            this.repositories.relatorioSaida.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioSaida.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            if (field != 'material') {

                field = `${field}Id`
            }

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'centroCustoId',
                'tipoId',
                'motivoId',
                'usuarioSaidaId',
                'unidadeRequisitanteId',
                'infraestruturaRequisitanteId',
                'centroCustoRequisitanteId',
                'usuarioRequisitanteId',
                'grupoId',
                'subgrupoId',
                'material',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioSaida.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.saidas
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioSaida(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioSaida(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')
            this.createIdKeysToObject(data, ['material'])

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
</style>